import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import {
    AccommodationUpgrade,
    AvailableAccommodationUpgrades
} from "../interfaces/availableAccommodationUpgrade";

export interface AccUpgradeState {
    availableAccommodationUpgrades: {
        days: AvailableAccommodationUpgrades[]
    },
    accommodationUpgrades?: AccommodationUpgrade|null
}

export const AccUpgradeInitialState: AccUpgradeState = {
    availableAccommodationUpgrades: {
        days: [],
    },
    accommodationUpgrades: null
}

export default {
    namespaced: false,
    state: AccUpgradeInitialState,
    mutations,
    actions,
    getters
}
